import { useRef, useState } from "react";
import { Download, Upload, AlertTriangle } from "lucide-react";
import api from "@/lib/api";

export default function BackupRestore() {
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const fileRef = useRef(null);

  const doBackup = async () => {
    setBusy(true);
    try {
      const { data } = await api.get("/admin/backup");
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `labpronics-backup-${new Date().toISOString().slice(0, 10)}.json`;
      a.click();
      setMsg("Backup downloaded successfully.");
    } catch (e) { setMsg("Backup failed: " + (e.response?.data?.detail || e.message)); }
    finally { setBusy(false); }
  };

  const doRestore = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!window.confirm("Restoring will REPLACE current content collections with the backup. Continue?")) { if (fileRef.current) fileRef.current.value = ""; return; }
    setBusy(true);
    try {
      const text = await file.text();
      const json = JSON.parse(text);
      const { data } = await api.post("/admin/restore", json);
      setMsg("Restored: " + Object.entries(data.restored).map(([k, v]) => `${k} (${v})`).join(", "));
    } catch (e2) { setMsg("Restore failed: " + (e2.response?.data?.detail || e2.message)); }
    finally { setBusy(false); if (fileRef.current) fileRef.current.value = ""; }
  };

  return (
    <div className="max-w-2xl">
      <h1 className="font-heading font-700 text-2xl text-lp-blue mb-6">Backup &amp; Restore</h1>
      <div className="bg-white border border-lp-border rounded-sm p-8 space-y-6">
        <div>
          <h3 className="font-heading font-600 text-lp-blue mb-1">Export Backup</h3>
          <p className="text-sm text-lp-muted mb-3">Download a JSON snapshot of all site content, pages, blog and collections.</p>
          <button onClick={doBackup} disabled={busy} data-testid="backup-btn" className="inline-flex items-center gap-2 bg-lp-blue text-white font-600 px-5 py-2.5 rounded-sm disabled:opacity-60"><Download size={16} /> Download Backup</button>
        </div>
        <div className="border-t border-lp-border pt-6">
          <h3 className="font-heading font-600 text-lp-blue mb-1">Restore from Backup</h3>
          <div className="flex items-start gap-2 text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-sm p-3 mb-3">
            <AlertTriangle size={16} className="shrink-0 mt-0.5" /> This replaces existing content collections. Media files are not affected.
          </div>
          <button onClick={() => fileRef.current?.click()} disabled={busy} data-testid="restore-btn" className="inline-flex items-center gap-2 border border-lp-blue text-lp-blue font-600 px-5 py-2.5 rounded-sm disabled:opacity-60"><Upload size={16} /> Upload &amp; Restore</button>
          <input ref={fileRef} type="file" accept="application/json,.json" className="hidden" onChange={doRestore} />
        </div>
        {msg && <p className="text-sm text-lp-ink bg-lp-grey rounded-sm p-3">{msg}</p>}
      </div>
    </div>
  );
}
